import { createStyles, makeStyles } from "@material-ui/styles";
import { baseColors, RelodeTheme } from "../";

export const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            appBar: {
                position: "relative",
                boxShadow: "0 2px 14px 0 rgba(26,48,108,0.1)",
            },
            titleWrapper: {
                display: "flex",
                overflow: "hidden",
                marginRight: 100,
                alignItems: "center",
            },
            title: {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                paddingRight: theme.spacing(1),
                fontStyle: "none",
            },
            content: {
                display: "flex",
                flexDirection: "row",
                flexGrow: 1,
                height: "auto",
                minHeight: "100%",
            },
            stepContentArea: {
                display: "flex",
                flexGrow: 1,
                width: "100%",
                flexDirection: "column",
            },
            stepper: {
                flexGrow: 0,
                width: 300,
                backgroundColor: "#FBFAFD",
            },
            steps: {
                backgroundColor: "#FBFAFD",
            },
            step: {
                display: "flex",
                height: "100%",
                flexGrow: 1,
            },
            stepButton: {
                marginRight: theme.spacing(2),
                width: 120,
            },
            cancelButton: {
                marginLeft: theme.spacing(1),
            },

            paper: {
                overflowY: "hidden",
            },
            errorIcon: {
                alignSelf: "center",
                height: "100%",
                display: "flex",
                marginRight: theme.spacing(1),
            },
            stepContent: {
                paddingLeft: "28px",
            },
            stepInactive: {
                fontSize: 18,
                color: baseColors.black,
            },
            wizardContentArea: {
                flexGrow: 1,
                flexBasis: "50%",
                display: "flex",
                minHeight: "100%",
            },
            button: {
                marginLeft: theme.spacing(1),
            },
            stepLabel: {
                color: theme.palette.grey[700],
            },
            stepContainer: {
                display: "flex",
                height: "100%",
            },
        }),
    { name: "Wizard", classNamePrefix: "relode" }
);
